import type { VideoElements } from "./elements";
import { whenTextTrackCuesReady } from "./text_track";
import { createCueHighlight, type CueHighlight } from "./current_cue_highlight";
import { renderTimeline } from "./timeline_renderer";
import { buildTimelineTree, Timeline } from "../../../model/manuals/lecture_video";

const setupVideoPage = (els: VideoElements): void => {
  const cueHighlight = createCueHighlight();
  whenTextTrackCuesReady(els.trackElement, (trackCues) => {
    const timeline = Timeline.fromTextTrackCues(trackCues);
    _mountTimeline(timeline, els, cueHighlight);
  });
};

const _mountTimeline = (
  timeline: Timeline,
  els: VideoElements,
  cueHighlight: CueHighlight,
): void => {
  const root = buildTimelineTree(timeline.cues);
  els.timelineRoot.replaceChildren(
    renderTimeline(root, els.video, cueHighlight.seekButtonsByStartTime),
  );

  const sync = () => cueHighlight.activate(els.video.currentTime, timeline.cues);
  els.video.addEventListener("timeupdate", sync);
  els.video.addEventListener("seeked", sync);
  sync();
};

export { setupVideoPage };
